module.exports = __webpack_public_path__ + "static/img/kaiyuan.8226f92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/kaiyuan.png
// module id = 4UY/
// module chunks = 3